import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCoin2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-0-stroke-1.5-IconCoin2"><Path fillRule="evenodd" clipRule="evenodd" d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM11.2929 8.70711L8.70711 11.2929C8.31658 11.6834 8.31658 12.3166 8.70711 12.7071L11.2929 15.2929C11.6834 15.6834 12.3166 15.6834 12.7071 15.2929L15.2929 12.7071C15.6834 12.3166 15.6834 11.6834 15.2929 11.2929L12.7071 8.70711C12.3166 8.31658 11.6834 8.31658 11.2929 8.70711Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCoin2;
